import { axios } from '@vivaldis/common'
import { useUser } from '@vivaldis/session'
import { jwtDecode } from 'jwt-decode'
import { useSearchParams } from 'react-router-dom'

const KEY_FOR_CONNEXYS_TOKEN = 'connexysToken'

const QUERY_PARAM_NAME_FOR_TOKEN = 'connexysToken'

type ConnexysTokenJwtPayload = {
  company_connexys_id: string
  consultant_name: string
}

export const useConnexysToken = () => {
  const user = useUser()
  const [searchParams] = useSearchParams()

  // when user is logged in, we don't support connexys token
  if (user) {
    return undefined
  }

  // token in query params is base64 encoded
  const base64EncodedConnexysJWTToken = searchParams.get(
    QUERY_PARAM_NAME_FOR_TOKEN
  )

  let connexysJWTToken = base64EncodedConnexysJWTToken
    ? atob(base64EncodedConnexysJWTToken)
    : null

  if (connexysJWTToken) {
    sessionStorage.setItem(KEY_FOR_CONNEXYS_TOKEN, connexysJWTToken)
  } else {
    connexysJWTToken = sessionStorage.getItem(KEY_FOR_CONNEXYS_TOKEN)
  }

  if (connexysJWTToken) {
    // delete headers for normal user
    delete axios().defaults.headers.common['X-User-Token']
    delete axios().defaults.headers.common['X-User-Email']
    // set header for JWT token from connexys
    axios().defaults.headers.common['Authorization'] =
      `Bearer ${connexysJWTToken}`

    return jwtDecode<ConnexysTokenJwtPayload>(connexysJWTToken)
  }

  return undefined
}
